import { useDispatch, useSelector } from "react-redux";
import { componentKey as fileBoiComponentKey, setGridSelectedRecipients, setIsBeneficialSelectAllSelected, setIsBeneficiaryAddEditPopupOpen, setRecipientListPaginationState, setReloadBeneficiaryList, setStepperRefreshStep } from "../../FileBoiSlice";
import styles from './BeneficialOwners.styles';
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import { VEC_ICON_NAME } from "../../../../../components/icons/constants";
import { deleteBeneficiary, getBeneficiaryOwners, requestBeneficiaryOwnerEmail } from "../../FileBoiSaga";
import Heading from "../../../../../components/heading/Heading";
import { HEADING } from "../../../../../components/heading/constants/constants";
import RichGrid from "../../../../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../../../../components/richgrid/constants";
import Label from "../../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../../components/label/constants";
import { useEffect, useState } from "react";
import BeneficiaryOwner from "../../../../components/beneficiaryowner/BeneficiaryOwner";
import Icons from "../../../../../components/icons/Icons";
import Loadable from "../../../../../components/loadable/Loadable";
import { FILE_BOI_LOADING_STATES, FILE_BOI_LOADING_STATES_MESSAGE_MAP } from "../../../constants";
import TextInput from "../../../../../components/input/textinput/TextInput";
import useDelayedAction from "../../../../../../libs/customhooks/useDelayedAction";
import TxTooltipWIcon from "../../../../../components/tooltip/txtooltipwicon/TxTooltipWIcon";

export default function BeneficialOwnersList(){
    
    const { loadingState, recipientListPaginationState, recipientList, gridSelectedRecipients, gridSelectedPayers, isBeneficiaryAddEditPopupOpen, reportingCompanyDetailId, reloadBeneficiaryList, onDependentFields, formsPreLoadedData, isBeneficialSelectAllSelected, formRecordId } = useSelector(state => state[fileBoiComponentKey])
    const [beneficialIdForEdit, setBeneficialIdForEdit] = useState(null);
    const dispatch = useDispatch();

    const handleEditBeneficialClk = (row) => {
        setBeneficialIdForEdit(row?.BeneficialOwnerDetailId)
        dispatch(setIsBeneficiaryAddEditPopupOpen(true))
    }

    const BENEFICIAL_OWNERS_GRID_COLUMNS = [
        {
            field: "boi",
            header: <Label weight={LABEL_WEIGHT[700]}>BOI</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.LastName ?? "" }</span>
        },
        {
            field: "tin",
            header: <Label weight={LABEL_WEIGHT[700]}>FINCen ID</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.IdNumber }</span>
        },
        {
            field: "email",
            header: <Label weight={LABEL_WEIGHT[700]}>Email</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.emailid }</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.BoiStatus }</span>
        },
        {
            field: "request_date",
            header: <Label weight={LABEL_WEIGHT[700]}>Request Date</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.BoiRequestedDate ?? ""}</span>
        },
        {
            field: "completed_date",
            header: <Label weight={LABEL_WEIGHT[700]}>Boi Completed Date</Label>,
            renderLogic: (row, idx) => <span style={styles.gridColumnText}>{ row?.BoiCompletedDate ?? "" }</span>
        },
        {
			field: "actions",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Actions</Label>,
			renderLogic: (row, idx) => <div style={styles.gridActions}>
                <Loadable currentState={loadingState.state} loadingStates={[`${FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_REQUEST_EMAIL_LOADING}-${row?.BeneficialOwnerDetailId}`]} messageMap={FILE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                    <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Simplify BOI information and document collection by effortlessly sending a secure email link directly to the Beneficial Owner for seamless communication'} onClickCb={() => dispatch(requestBeneficiaryOwnerEmail({BeneficialOwnerDetailId: row?.BeneficialOwnerDetailId}))}>
                        <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EMAIL_ICON} />
                    </Button>
                </Loadable>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Delete Beneficial'} onClickCb={() => dispatch(deleteBeneficiary({beneficialOwnerDetailId: row?.BeneficialOwnerDetailId}))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button> 
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit Beneficial'} onClickCb={() => handleEditBeneficialClk(row)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} /></Button> 
			</div>
		},
    ]

    useEffect(() => {
        if(reportingCompanyDetailId){
            handleGetPaginatedRecipientsList(recipientListPaginationState?.PageNumber, recipientListPaginationState?.PageSize, recipientListPaginationState)
        }
    }, [reportingCompanyDetailId])

    useEffect(() => {
        if(reloadBeneficiaryList){
            handleGetPaginatedRecipientsList(recipientListPaginationState?.PageNumber, recipientListPaginationState?.PageSize, recipientListPaginationState)
            dispatch(setReloadBeneficiaryList(false));
        }
    }, [reloadBeneficiaryList])

    useEffect(() => {
        dispatch(setRecipientListPaginationState({PageNumber: 1, Skip: 0}))
        handleGetPaginatedRecipientsList(1, recipientListPaginationState?.PageSize, {...recipientListPaginationState, PageNumber: 1, Skip: 0})
    } ,[recipientListPaginationState.FilterText])

    const handleGetPaginatedRecipientsList = useDelayedAction((pageNumber, pageSize, recipientListPaginationState = recipientListPaginationState) => {
        if(reportingCompanyDetailId){
            dispatch(getBeneficiaryOwners({
                ...recipientListPaginationState,
                PageSize: pageSize,
                PageNumber: pageNumber,
                PayerId: reportingCompanyDetailId,
                isBeneficialSelectAllSelected: isBeneficialSelectAllSelected,
            }))
        }
    })

    const updateSelectedGridRecord = (selectedRecordsFromGrid) => {
        dispatch(setGridSelectedRecipients(selectedRecordsFromGrid))
    }
    
    const onHeaderSelectionChangeCallBackFn = (data) => {
        if(data.length > 0){
            dispatch(setIsBeneficialSelectAllSelected(true))
            updateSelectedGridRecord(data)
        }else{
            dispatch(setIsBeneficialSelectAllSelected(false))
            updateSelectedGridRecord(data)
        }
    }

    return <>
        <Heading type={HEADING.H1} customStyle={styles.selectReportingCompanytitle}>Select Beneficial Owner</Heading>
        <div style={styles.addBtnDiv}>
            <div style={styles.flexOne}>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search with beneficial owner name: </Label>
                <TextInput
                    type={'text'}
                    placeHolder={"Beneficial Owner"}
                    name={'beneficialOwner'}
                    value={recipientListPaginationState?.FilterText}
                    onChangeCb={(e) => dispatch(setRecipientListPaginationState({FilterText: e.target.value}))}
                />
            </div>
            <Button style={styles.addBtnStyles} type={BUTTON_TYPE.PRIMARY} onClickCb={() => {setBeneficialIdForEdit(null);dispatch(setIsBeneficiaryAddEditPopupOpen(true))}}>Add New Beneficiary Owner</Button>
        </div>
        
        <Loadable currentState={loadingState.state} loadingStates={[FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_LOADING]} messageMap={FILE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
            <RichGrid
                selectable={true}
                showHeaderSelectionCheckbox={true}
                onHeaderSelectionChangeCallBack={(data) => onHeaderSelectionChangeCallBackFn(data)}
                data={recipientList}
                columns={BENEFICIAL_OWNERS_GRID_COLUMNS}
                extractRowKey={(row) => row?.BeneficialOwnerDetailId}
                selectedRows={gridSelectedRecipients}
                onSelectionChangeCallBack={(selectedData) => updateSelectedGridRecord(selectedData)}
                paginationProps={{
                    skip: recipientListPaginationState?.Skip,
                    take: recipientListPaginationState?.PageSize,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(setRecipientListPaginationState({PageSize: newTake, Skip: 0, PageNumber: 1}))
                        handleGetPaginatedRecipientsList(1, newTake, {...recipientListPaginationState, PageSize: newTake, Skip: 0, PageNumber: 1})
                    },
                    total: recipientListPaginationState?.totalRecords,
                    onChange: (take, t) => {
                        dispatch(setRecipientListPaginationState({PageSize: take, Skip: t, PageNumber: (t / take) + 1}))
                        handleGetPaginatedRecipientsList((t / take) + 1, take, {...recipientListPaginationState, PageSize: take, Skip: t, PageNumber: (t / take) + 1})
                    },
                }}
            />
        </Loadable>
        
        {
            isBeneficiaryAddEditPopupOpen && <BeneficiaryOwner 
                isOpen={isBeneficiaryAddEditPopupOpen} 
                onCloseCb={() => {setBeneficialIdForEdit(null); dispatch(setIsBeneficiaryAddEditPopupOpen(false))}} 
                onFinalSubmitCb={(detailId) => handleGetPaginatedRecipientsList(recipientListPaginationState?.PageNumber, recipientListPaginationState?.PageSize, recipientListPaginationState)} 
                payerDetailId={reportingCompanyDetailId}
                formsPreLoadedDataFromParent={formsPreLoadedData}
                onDependentFields={onDependentFields}
                beneficialOwnerDetailId={beneficialIdForEdit}
                formRecordId={formRecordId}
            />
        }
        
    </>
}